import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'

// Components
import AdminProductForm from './AdminProductForm'
import AdminProductEdit from './AdminProductEdit'

// State
import { addRoute } from '../../../store/actions/route'
import { setpageTitle } from '../../../store/actions/siteInfo'

class AdminProduct extends Component {
    constructor(props) {
        super(props)
        this.props.addRoute(this.props.match)

        if (props.match.path === '/admin/products/edit') {
            this.props.setpageTitle('Edit Product')
        } else {
            this.props.setpageTitle('Add Product')
        }
    }

    render() {
        return (
            <Switch>
                <Route path={'/admin/products/add'} exact component={AdminProductForm} />
                <Route path={'/admin/products/edit'} component={AdminProductEdit} />
            </Switch>
        )
    }
}


export default connect(null, { addRoute, setpageTitle })(AdminProduct)



// WEBPACK FOOTER //
// ./src/components/admin/products/AdminProduct.js